module.exports = __webpack_public_path__ + "img/app-banner-close.58bfac5.png";